module.exports = __webpack_public_path__ + "img/img4.c83e9ea8.jpg";